export const cookieNames = {
  teacher_session_id: "session_id",
};

const DOMAIN_NAME =
  process.env.NODE_ENV === "production" ? "enageed.net" : "localhost";

function set(cookieName: string, cookieValue: string, days: number) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = `${cookieName}=${cookieValue};${expires};domain=${DOMAIN_NAME};path=/`;
}

function getCookie(c_name: string) {
  const regex = new RegExp("(?:^|; )" + c_name + "=([^;]*)");
  const match = document.cookie.match(regex);
  return match ? decodeURIComponent(match[1]) : "";
}

function deleteAll() {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      name +
      `=;domain=${DOMAIN_NAME};path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }
}

export default {
  set,
  getCookie,
  deleteAll,
};
